export enum SessionStorageKeys {
    USER_IMAGE = 'USER_IMAGE',
    LOGO_IMAGE = 'LOGO_IMAGE',
    SESSION = "SESSION",
    CODES = "CODES"
}